module.exports = __webpack_public_path__ + "img/logo-text.ed54a748.svg";